import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn, faGithub, faInstagram } from '@fortawesome/free-brands-svg-icons';

export default function Contact() {
  return (
    <div className='bg-primary' id='contact'>
      <div className="container mx-auto px-[3%] py-[3%]">
        <div className='grid lg:grid-cols-3 grid-cols-none lg:grid-rows-none grid-rows-3 gap-8 justify-items-center text-center text-primary'>
          <div className='border border-[#8cb7be] lg:w-full h-full bg-[#f1f3e9] px-4 py-6 w-2/3'>
            <p className='uppercase font-bold md:text-3xl text-xl'>Address</p>
            <hr className='border border-[#8cb7be] mx-auto my-3'/>
            <p className='font-medium font-formal md:text-sm text-xs'>Jl K Irsyad, Desa Lebakwangi, Kec. Jatinegara, Kab. Tegal, Jawa Tengah</p>
          </div>
          <div className='border border-[#8cb7be] lg:w-full h-full bg-[#f1f3e9] px-4 py-6 w-2/3'>
            <p className='uppercase font-bold md:text-3xl text-xl'>Email</p>
              <hr className='border border-[#8cb7be] mx-auto my-3'/>
            <a href='mailto:ulfatunamanah482@gmail.com' className='font-medium font-formal md:text-sm text-xs hover:underline'>ulfatunamanah482@gmail.com</a>
          </div>
          <div className='border border-[#8cb7be] lg:w-full h-full bg-[#f1f3e9] px-4 py-6 w-2/3'>
            <p className='uppercase font-bold md:text-3xl text-xl'>Phone</p>
              <hr className='border border-[#8cb7be] mx-auto my-3'/>
            <p className='font-medium font-formal md:text-sm text-xs'>+62 895-3933-8975-7</p>
          </div>
        </div>
        <div className="flex justify-center items-center mt-[7%]">
          <a href='https://www.linkedin.com/in/ulfatun-amanah-24516521a/' className='flex items-center justify-center hover:bg-[#f1f3e9] bg-[#c8dbda] w-12 h-12 rounded-full text-center mx-2 cursor-pointer'>
            <FontAwesomeIcon icon={faLinkedinIn} className='text-primary' />
          </a>
          <a href='https://github.com/UlfatunAmanah482' className='flex items-center justify-center hover:bg-[#f1f3e9] bg-[#c8dbda] w-12 h-12 rounded-full text-center mx-2 cursor-pointer'>
            <FontAwesomeIcon icon={faGithub} className='text-primary' />
          </a>
          <a href='https://www.instagram.com/ulfatun_amanah/' className='flex items-center justify-center hover:bg-[#f1f3e9] bg-[#c8dbda] w-12 h-12 rounded-full text-center mx-2 cursor-pointer'>
            <FontAwesomeIcon icon={faInstagram} className='text-primary' />
          </a>
        </div>
      </div>
    </div>
  )
}
